<template>
  <main class="document-page">
    <TopBar :page-header="$t('sidebar.documents')" />
    <div class="content">
      <div class="document-container">
        <div class="container">
          <template v-if="!documents || documents.length === 0">
            {{ $t("documentPage.noDocuments") }}
          </template>
          <template v-else>
            <rowResp :gutter="12">
              <columnResp v-for="document in documents"
                          :key="document.Id"
                          :xs="12"
                          :md="6"
                          :lg="6"
                          :xl="6"
              >
                <div class="documentcard"
                     @click="downloadFile(document)"
                >
                  <div v-if="['jpg','jpeg','gif','png','bmp'].indexOf(document.Extension) > -1">
                    <span class="material-icons big-icons">image</span>
                  </div>
                  <div v-else-if="['pdf','docx','doc','txt'].indexOf(document.Extension) > -1">
                    <span class="material-icons big-icons">description</span>
                  </div>
                  <div v-else>
                    <span class="material-icons big-icons">question_mark</span>
                  </div>
                  {{ document.Name }}
                </div>
              </columnResp>
            </rowresp>
          </template>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import TopBar from "../components/TopBar.vue";
import { computed, onMounted } from 'vue'
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import i18n from '../locales/i18n'
  
const toast = useToast();
const store = useStore();

const documents = computed(() => store.state.documents.documents)


onMounted(async () => {
  store.dispatch('documents/getDocuments');
});


async function downloadFile(documentInfo){
  try{
    const byteCharacters = window.atob(documentInfo.Base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/' + documentInfo.Extension })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = documentInfo.Name+"."+ documentInfo.Extension;
    link.click()
    URL.revokeObjectURL(link.href)
  }
  catch(e){
    toast.error( i18n.global.t('documentPage.DownloadFailed') +"\r\n\r\n"+ e.message )
  }
  
}


</script>


<style lang="scss" scoped>

.document-page {
  height: 100vh;
  overflow-y: scroll;
  font-family: "Be Vietnam Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  background: #ffffff;
  width:100%;
  .content {
    height: calc(100% - 90px);
    padding: 2rem;
  }
}

@media(max-width:768px) {
      .document-page .content{
        padding-top: 6rem;
        min-width: unset;
        width:1;
      }
  }
.document-container{
    min-height: 300px;
    display: flex;
    justify-content: space-around;
    .container{
        padding: 1rem;
        background: #ffffff;
        width: 100%;
        max-width: 600px;
        border: 2px solid var(--backgroundNew2);
        border-radius: 1rem;
        overflow: auto;
    }
    .documentcard{
      
      border-radius: 1rem;
      background-color: #E6E6E6;
      color: #000000;
      padding: 0.5rem;
      margin: 0.5rem;
      word-break: break-word;
      cursor: pointer;
    }
    .big-icons{
      font-size: 50px;
    }
    @media(max-width:768px) {
    .big-icons{
      font-size: 30px;
    }
  }
}


</style>
